import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs-compat";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root"
})
export class FetchDataService {
  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  private getAuthHeaders(): HttpHeaders {
    const token = localStorage.getItem('token');
    return new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });
  }

  login(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/login`, data ,);
  }
  refreshToken(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/refresh`, data, );
  }

  registerEmail(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/emailverify`, data ,{ headers: this.getAuthHeaders() });
  }


  verifyEmail(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/validatelink`, data );
  }

  track(userTrackPayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/usertrack`, userTrackPayload);
  }

  signup(register): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/signup`, register ,{ headers: this.getAuthHeaders() });
  }

  forgetPassword(email): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/forgotpassword`, email ,{ headers: this.getAuthHeaders() });
  }

  resetPassword(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/resetpassword`, data ,{ headers: this.getAuthHeaders() });
  }

  changePassword(data): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/change-password`, data,{ headers: this.getAuthHeaders() } );
  }

  getCountryCodes() {
    return this.http.get(`${this.baseUrl}/api/getCountries`,{ headers: this.getAuthHeaders() });
  }

  getTotalUnreadMsgs(userId) {
    return this.http.get(`${this.baseUrl}/api/totaluread?receiver_id=${userId}`,{ headers: this.getAuthHeaders() } );
  }

  getProfileList(uid, token): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/getprofile?id=${uid}`,{ headers: this.getAuthHeaders() } );
  }

  uploadBanner(file: File, uid: string, email: string): Observable<any> {
    const formData = new FormData();
    formData.append('banner', file);
    formData.append('uid', uid);
    formData.append('email', email);
    return this.http.post(`${this.baseUrl}/api/uploadbanner`, formData,{ headers: this.getAuthHeaders() } );
  }

  uploadLogo(file: File, uid: string, email: string): Observable<any> {
    const formData = new FormData();
    formData.append('logo', file);
    formData.append('uid', uid);
    formData.append('email', email);
    return this.http.post(`${this.baseUrl}/api/uploadlogo`, formData,{ headers: this.getAuthHeaders() } );
  }

  updateAboutText(data: { about: string, uid: string, email: string }): Observable<any> {
    return this.http.post(`${this.baseUrl}/api/uploadabout`, data,{ headers: this.getAuthHeaders() } );
  }

  getUserProfileData(uid: string, token: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/api/getProfile?uid=${uid}`,{ headers: this.getAuthHeaders() } );
  }

  getProfileData(id: string) {
    return this.http.get(`${this.baseUrl}/api/profile?id=${id}`,{ headers: this.getAuthHeaders() } );
  }

  profileSellerList(uid: string) {
    return this.http.get(`${this.baseUrl}/api/contentlist?uid=${uid}`, { headers: this.getAuthHeaders() });
  }

  profileTrailerList(uid: string) {
    return this.http.get(`${this.baseUrl}/api/contentlist?uid=${uid}`,{ headers: this.getAuthHeaders() } );
  }

  profileSellerListPost(payload: any) {
    return this.http.post(`${this.baseUrl}/api/addprofile_recent`, payload,{ headers: this.getAuthHeaders() } );
  }

  profileTrailerListPost(payload: any) {
    return this.http.post(`${this.baseUrl}/api/addprofile_promo`, payload,{ headers: this.getAuthHeaders() } );
  }

  getProfileSlider(uid: string) {
    return this.http.get(`${this.baseUrl}/api/profile_recentlist?uid=${uid}`,{ headers: this.getAuthHeaders() } );
  }

  getProfileSliderTrailer(uid: string) {
    return this.http.get(`${this.baseUrl}/api/profile_promolist?uid=${uid}`,{ headers: this.getAuthHeaders() } );
  }

  profileRecentDelete(uid: string, imageId: string) {
    return this.http.get(`${this.baseUrl}/api/delete_profilerecent?uid=${uid}&id=${imageId}`, { headers: this.getAuthHeaders() });
  }

  editTrailerProfile(requestData: any) {
    return this.http.post(`${this.baseUrl}/api/editprofile_promo`, requestData,{ headers: this.getAuthHeaders() } );
  }

  updateSliderImage(requestData: any) {
    return this.http.post(`${this.baseUrl}/api/editprofile_recent`, requestData,{ headers: this.getAuthHeaders() } );
  }

  // deleteSliderImage(requestData: any) {
  //   const params = new HttpParams()
  //     .set('uid', requestData.uid)
  //     .set('id', requestData.id);
  //   return this.http.get(`${this.baseUrl}/api/delete_profilerecent`,{ headers: this.getAuthHeaders() } );
  // }
  deleteSliderImage(requestData: any) {
  const params = new HttpParams()
    .set('uid', requestData.uid)
    .set('id', requestData.id);

  return this.http.get(`${this.baseUrl}/api/delete_profilerecent`, {
    headers: this.getAuthHeaders(),
    params: params
  });
}


  updateSliderTrailer(requestData: any) {
    return this.http.post(`${this.baseUrl}/api/editprofile_promo`, requestData,{ headers: this.getAuthHeaders() } );
  }

  deleteSliderTrailer(requestData: any) {
    const params = new HttpParams()
      .set('uid', requestData.uid)
      .set('id', requestData.id);
    return this.http.get(`${this.baseUrl}/api/delete_profilepromo`,{params: params, headers: this.getAuthHeaders() } );
  }

saveNewsletter(email: string) {
  return this.http.post(
    `${this.baseUrl}/api/save-newsletter`,
    { email }
  );
}
createSecondUser(data: any): Observable<any> {
  return this.http.post(
    `${this.baseUrl}/api/create-2n-user`,
    data,
    { headers: this.getAuthHeaders() }
  );
}
switchSecondUser(data:any):Observable<any>{
  return this.http.post(`${this.baseUrl}/api/switch-role`,
    data,
    {
      headers:this.getAuthHeaders()
    }
  )
}

}
